module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAeCAMAAACVFoclAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAABmUExURUdwTKzG/zJm/zFk/zJl/63I/6zI/63H/67I/zNm/6/K/6/J/zFl/y9l/4+p/67J/67J/63L/zJm/zBk/zJl/67J/zJk/zNl/zJl/67I/67K/67J/67J/63I/63I/63J/zNm/67J/2K8f9sAAAAgdFJOUwBseodg93hgv1+ff8MwDLDnHPFNtc2X2aFAkZ4vonBRtO0IGAAAAKdJREFUKM/FktkSgjAMRSNSWpUu2AGBupD//0mFkSLStI+cx/RMmpsJKMeQhjkFD4zjgKHmNBoNIBZAc0A2GfIURnojG8IcdzJKZfOmjBpTwlvEuI5CtMdkNHFDtr9NAlnsWF0GIdJmYFP7aHfbuszDLPdB8/wYBo2gMVgDT9w6B+j68xfty3ou9d3q08obd2KshFEJUXujFrraGP8TvzaGuqwo1PzwBnSVSXDTNoW9AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MallPage/manufacture.png
// module id = kxjD
// module chunks = 0